import { t } from '@trimble/i18n';
import { Component, createMemo } from 'solid-js';
import { HeatmapSectionLabel } from '../components/HeatmapSectionLabel';
import { heatmapHorizontalPreviewCss } from '../heatmap-stop-layout';
import { HeatmapPreviewBar } from './HeatmapPreviewBar';
import { EditablePalette } from '../types/heatmap.types';

interface GradientPreviewProps {
  palette: EditablePalette;
}
export const GradientPreview: Component<GradientPreviewProps> = (props) => {
  const previewCss = createMemo(() =>
    heatmapHorizontalPreviewCss(
      props.palette.stops,
      props.palette.textureType,
      {
        above: props.palette.colorAboveRange,
        below: props.palette.colorBelowRange,
      }
    )
  );
  const textureDescription = createMemo(() =>
    props.palette.textureType === 'stepped'
      ? t('measurements.volumetric.gradient.textureSteppedDesc')
      : t('measurements.volumetric.gradient.textureGradientDesc')
  );
  return (
    <div class="flex flex-col gap-1">
      <HeatmapSectionLabel
        uppercase
        label={t('measurements.volumetric.gradient.textureLabel')}
      />
      <HeatmapPreviewBar
        stops={props.palette.stops}
        backgroundCss={previewCss()}
        testId="gradient-preview"
      />
      <span class="text-xs text-gray-6">{textureDescription()}</span>
    </div>
  );
};
